import React, { Component, Fragment } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  Fade,
  Alert,
} from "reactstrap";
import Header from "../components/partials/Header";
import Footer from "../components/partials/Footer";
import { connect } from "react-redux";
import { getContent } from "../redux/actions/contentActions";
import axios from "axios";
import moment from "moment";
import { mailReset, queryMail } from "../redux/actions/mailActions";

export class TeamBuilding extends Component {
  state = {
    alert: 0,
  };
  componentDidMount() {
    this.props.getContent();
  }
  setAlert = (code) => {
    this.setState({
      alert: code,
    });
  };
  render() {
    let { mailsent, loading } = this.props;
    var { content } = this.props;
    return (
      <Fragment>
        <Header
          {...this.props}
          login={false}
          path={["Home", "Team Building Activities"]}
          heading="Team Building Activites"
        />
        <div className="margin-top-fix text-white-1">
          <p className="text-center header-p font-weight-regular">
            Our Successful Team Build Your Wonderful Events
          </p>
          <Container>
            <div className="team-container">
              <div className="team-image-1"></div>

              <div className="team-desc team-desc-1 bg-dark-1 ">
                <div className="team-desc-content">
                  <h5 className="text-red-1 font-weight-700">
                    <b>
                      {content && content.length
                        ? content.find((con) => con.label == "About Our Teams")
                            .title
                        : null}
                    </b>
                  </h5>
                  <p className="text-lightpurple-1 team-desc-content-p justify-content-center">
                    {content && content.length
                      ? content.find((con) => con.label == "About Our Teams")
                          .description
                      : null}
                  </p>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <div>
          <Container>
            <Row className="justify-content-center">
              <Col xl={6} md={12}>
                <h4 className="text-red-1 font-weight-400 mt-5">
                  <b>
                    {content && content.length
                      ? content.find((con) => con.label == "History").title
                      : null}
                  </b>
                </h4>
                <p className="mt-4 text-lightpurple-1 team-desc-content-p justify-content-center">
                  {content && content.length
                    ? content.find((con) => con.label == "History").description
                    : null}
                </p>
              </Col>
              <Col xl={3} md={6} className="mt-4">
                <div className="team-img team-image-2"></div>
              </Col>
              <Col xl={3} md={6} className="mt-4">
                <div className="team-img team-image-3"></div>
              </Col>
            </Row>
          </Container>
          {/*  <Container>
            <div className="team-container mt-5">
              <div className="team-desc team-desc-2 bg-dark-1 mt-3">
                <div className="team-desc-content">
                  <h4 className="text-red-1 font-weight-400 ">
                    <b>
                      {content && content.length
                        ? content.find((con) => con.label == "Activities").title
                        : null}
                    </b>
                  </h4>
                  <p className="text-lightpurple-1 team-desc-content-p justify-content-center">
                    {content && content.length
                      ? content.find((con) => con.label == "Activities")
                          .description
                      : null}
                  </p>
                </div>
              </div>

              <div className="team-image-4"></div>
            </div>
          </Container>
          <Container>
            <Row className="justify-content-center">
              <Col xl={6} md={12}>
                <h4 className="text-red-1 font-weight-400 mt-5">
                  <b>
                    {content && content.length
                      ? content.find((con) => con.label == "Experience").title
                      : null}
                  </b>
                </h4>
                <p className="mt-4 text-lightpurple-1 team-desc-content-p justify-content-center">
                  {content && content.length
                    ? content.find((con) => con.label == "Experience")
                        .description
                    : null}
                </p>
              </Col>
              <Col xl={3} md={6} className="mt-4">
                <div className="team-img team-image-5"></div>
              </Col>
              <Col xl={3} md={6} className="mt-4">
                <div className="team-img team-image-6"></div>
              </Col>
            </Row>
          </Container>
          */}
          {/* <Container>
            <Row>
              <div>
                <h4 className="text-red-1 font-weight-400 mt-5">
                  <b>
                    {content && content.length
                      ? content.find((con) => con.label == "Our Team").label
                      : null}
                  </b>
                </h4>
                <p className="mt-4 text-lightpurple-1 team-desc-content-p justify-content-center">
                  {content && content.length
                    ? content.find((con) => con.label == "Our Team").description
                    : null}
                </p>
              </div>
            </Row>
            <Row className="justify-content-center">
              <Col xl={3} md={6}>
                <div className="team-img bg-grey-2"></div>
              </Col>
              <Col xl={3} md={6}>
                <div className="team-img bg-grey-2"></div>
              </Col>
              <Col xl={3} md={6}>
                <div className="team-img bg-grey-2"></div>
              </Col>
              <Col xl={3} md={6}>
                <div className="team-img bg-grey-2"></div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col xl={3} md={6}>
                <div className="team-img bg-grey-2"></div>
              </Col>
              <Col xl={3} md={6}>
                <div className="team-img bg-grey-2"></div>
              </Col>
              <Col xl={3} md={6}>
                <div className="team-img bg-grey-2"></div>
              </Col>
              <Col xl={3} md={6}>
                <div className="team-img bg-grey-2"></div>
              </Col>
            </Row>
          </Container> */}
        </div>
        <div className="mt-5 mb-5">
          <div className="img-bg  text-white-1 pb-5">
            <Container>
              <h3 className="font-2 pt-5">Get In Touch !</h3>
              <p className="font-2 pt-2">
                Get More Information About Price Request And Policy
              </p>
              <Row>
                <Col>
                  {mailsent == true ? (
                    <Fade
                      in={mailsent == true}
                      onEnter={(e) => {
                        window.setTimeout(() => this.props.mailReset(), 5000);
                      }}
                    >
                      <Alert isOpen={mailsent == true} color="success">
                        Message Sent.
                      </Alert>
                    </Fade>
                  ) : mailsent == false ? (
                    <Fade
                      in={mailsent == false}
                      onEnter={(e) => {
                        window.setTimeout(() => this.props.mailReset(), 5000);
                      }}
                    >
                      <Alert isOpen={mailsent == false} color="danger">
                        Opps! Some Error Occured!
                      </Alert>
                    </Fade>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg={9}>
                  <Form
                    onSubmit={async (e) => {
                      e.preventDefault();
                      let obj = {
                        name: e.target.name.value,
                        company_name: e.target.c_name.value,
                        respond_email: e.target.email.value,
                        location: e.target.location.value,
                        num_players: e.target.num_players.value,
                        message: e.target.message.value,
                        email: "a.omar@springyuniverse.com",
                        date: moment().format("YYYY-MM-dd"),
                      };

                      this.props.sendMail(obj);
                    }}
                  >
                    <Row className="mt-2 ">
                      <Col md={6}>
                        <FormGroup>
                          <Input
                            type="text"
                            placeholder="Name"
                            name="name"
                            required
                            className="form-control mt-2"
                          />
                        </FormGroup>
                        <FormGroup>
                          <Input
                            type="text"
                            placeholder="Company Name"
                            name="c_name"
                            required
                            className="form-control mt-4"
                          />
                        </FormGroup>
                        <FormGroup>
                          <Input
                            type="email"
                            placeholder="Email"
                            name="email"
                            required
                            className="form-control mt-4"
                          />
                        </FormGroup>
                        <FormGroup>
                          <Input
                            type="text"
                            placeholder="Location"
                            name="location"
                            required
                            className="form-control mt-4"
                          />
                        </FormGroup>
                        <FormGroup>
                          <Input
                            type="number"
                            placeholder="Num Players"
                            name="num_players"
                            required
                            className="form-control mt-4"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Input
                            type="textarea"
                            placeholder="Message"
                            name="message"
                            required
                            className="form-control mt-4 mt-md-2"
                          />
                        </FormGroup>
                        <Button
                          disabled={loading}
                          block
                          className="w-100 mt-3 bg-purple-1 border-0 py-4 "
                          style={{ borderRadius: 24 }}
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.mail.loading,
    mailsent: state.mail.mailsent,
    content: state.content.content,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    sendMail: (mail) => dispatch(queryMail(mail)),
    mailReset: () => dispatch(mailReset()),
    getContent: () => dispatch(getContent()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TeamBuilding);
